import { makeStyles } from 'tss-react/mui';

const DEFAULT_HEIGHT = 300;

export const useStyles = makeStyles<{ height: number }>()((
  theme,
  { height },
) => {
  const galleryBackgroundColor =
    theme.palette.mode === 'dark'
      ? theme.palette.grey[700]
      : theme.palette.background.paper;

  return {
    wrapper: {
      backgroundColor: galleryBackgroundColor,
      height,
      minHeight: height,
      overflow: 'hidden',
      borderRadius: '10px',
      '& .image-gallery': {
        height: '100%',
      },
      '& .image-gallery-content': {
        height,
      },
      '& .image-gallery-slide-wrapper, & .image-gallery-swipe': {
        touchAction: 'pan-y pinch-zoom',
      },
      '& .image-gallery-slides': {
        touchAction: 'pan-y pinch-zoom !important',
      },
      '& .image-gallery-slide': {
        height,
        backgroundColor: galleryBackgroundColor,
      },
      '& .image-gallery-slide img': {
        height,
        objectFit: 'contain',
        touchAction: 'pan-y pinch-zoom',
      },
      '& .image-gallery-icon:hover': {
        color: theme.palette.primary.main,
      },
      '& .image-gallery-icon:focus': {
        outline: `2px solid ${theme.palette.primary.main}`,
      },
    },
  };
});

export { DEFAULT_HEIGHT };
